export type Transaction = Uint8Array;
